import React, { Component, Fragment } from "react";
import "./WaitingRoomScreen.scss";
import { CheckValue, getAvailableUser } from "../../../services/CommonFunction";
import { changeVolume } from "../../../components/UI/InputRange/InputRange";
import StopWatch from "../ChildComponentUI/StopWatch/StopWatch";
import AVControls from "../ChildComponentUI/AVControls/AVControls";
import TabLayout from "../ChildComponentUI/TabLayout/TabLayout";
import MembersVideoGrid from "../ChildComponentUI/MembersVideoGrid/MembersVideoGrid";
import PinnedUsers from "../ChildComponentUI/PinnedUsers/PinnedUsers";
import Chat from "../../../components/UI/Chat/Chat";
import Header from "../../../components/Header/Header";
import { selectIcon, SVG } from "../../../components/UI/selector";
import { staticVar } from "../../../services/Constants";
import Summary from "../ChildComponentUI/Summary/Summary";

export class WaitingRoomScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstTime: false,
      value: 100,
      id: "meeting-audio",
      chatSelected: false,
    };
    this.chatRef = React.createRef();
    this.paginationRef = React.createRef();
  }

  componentDidMount() {
    if (CheckValue(localStorage.getItem("setVolume"))) {
      changeVolume(
        parseInt(localStorage.getItem("setVolume"), 10),
        this.state.id,
        "null"
      );
    } else {
      changeVolume(100, this.state.id, "null");
    }
    localStorage.removeItem("firstTime");
  }

  statsClick = (status) => {
    const { zoom } = this.props;
    if (zoom && (status === "audio" || status === "camera")) {
      zoom.enableDisableAudioCamera(status);
    }
  };

  toggleChat = (isSelected) => {
    this.setState({ chatSelected: isSelected });
  };

  render() {
    const {
      totalSeconds,
      allUsers,
      tagUsers,
      userActivityData,
      required,
      workoutData,
      video_conference_data,
      activityStatus,
      stateSet,
      coachData,
      selfData,
      socket,
      userPin,
      themeColor,
      zoom,
      zoomData,
      gymData,
      staffsInActivity,
      leaveMeeting,
      canvas,
    } = this.props;
    const { value, id } = this.state;
    const isVideoStarted = coachData.host
      ? coachData.isVideoStarted
      : coachData.owner_isVideoStarted;

    const isHR = activityStatus === staticVar.hangoutRoom;
    let activeSpeakerText = null;
    if (
      zoomData.activeSpeaker &&
      allUsers.hasOwnProperty(zoomData.activeSpeaker.user_id)
    ) {
      if (allUsers[zoomData.activeSpeaker.user_id].me) {
        activeSpeakerText = "You are speaking...";
      } else {
        activeSpeakerText =
          allUsers[zoomData.activeSpeaker.user_id].first_name +
          " is speaking...";
      }
    }
    const chat = (
      <Chat
        ref={this.chatRef}
        workoutData={workoutData}
        gymName={gymData.name}
        staffsInActivity={staffsInActivity}
        coachData={coachData}
        memberData={allUsers[userActivityData.user_id]}
        userActivityData={userActivityData}
        userId={userActivityData.user_id}
        userSessionId={userActivityData.user_activity_session_id}
        chatUxToggle={this.state.chatSelected}
        socket={socket}
      />
    );

    const newMsgCount = localStorage.getItem("messageCount");
    var newMsgCountText = "";
    if (newMsgCount && newMsgCount > 0) {
      if (newMsgCount < 9) {
        newMsgCountText = " (" + newMsgCount + ")";
      } else {
        newMsgCountText = " (9+)";
      }
    }
    const msgCount = (
      <p>
        Chat{" "}
        <span style={{ color: "var(--color-primary)" }}>{newMsgCountText}</span>
      </p>
    );
    const { allUserLength } = getAvailableUser(allUsers, "not_ended");

    const tabData = [
      {
        title: "Participants: " + allUserLength,
        content: (
          <MembersVideoGrid
            allUsers={allUsers}
            tagUsers={tagUsers}
            userPin={userPin}
            chatRef={this.chatRef}
            paginationRef={this.paginationRef}
            zoom={zoom}
            isHangout={isHR}
          />
        ),
      },
      {
        title: msgCount,
        content: chat,
      },
    ];
    if (isHR) {
      tabData.push({
        title: "Summary",
        content: <Summary allUsers={allUsers} />,
      });
    }
    const leaveHelpBtns = (
      <div className={"btnParent"}>
        <a href={localStorage.getItem("supportLink")} target="_blank">
          <SVG
            className={"helpBtn"}
            src={selectIcon("contactSupport")}
            height={24}
            width={24}
          />
        </a>
        <button className={"leaveBtn"} type={"button"} onClick={leaveMeeting}>
          Leave
        </button>
      </div>
    );
    return (
      <Fragment>
        <Header
          title={isHR ? "Hangout" : "Waiting Room"}
          showLogo={false}
          showTitle={true}
          showStudio={false}
          showProfile={false}
        />
        <div className={"WaitingRoomScreen"}>
          <div className={"WRLeft"}>
            <div className="WRCoachVideoContainer box-layer1">
              <img
                className={"coachProfile"}
                src={coachData.profile_pic_thumb}
              />
              {canvas}
              {/* <canvas
                id="coach_canvas_view"
                className={"WRCoachVideo"}
                width="1920"
                height="1080"
              ></canvas> */}
              {!isHR ? (
                <div className={"pinnedUsersContainer"}>
                  <PinnedUsers
                    tagUsers={tagUsers}
                    allUsers={allUsers}
                    userPin={userPin}
                  />
                </div>
              ) : null}
            </div>
            <div className={"WRControlsParent box-layer1"}>
              <div></div>
              <div className={"cntrlParent"}>
                <AVControls
                  id={id}
                  value={value}
                  required={required}
                  controlClick={this.statsClick}
                  zoom={zoom}
                  zoomData={zoomData}
                  selfData={selfData}
                  soundSetting={"default"}
                />
              </div>
              {!isHR ? leaveHelpBtns : <div></div>}
            </div>

            <div className={"WRFooter box-layer1"}>
              {isHR ? leaveHelpBtns : null}
              {activeSpeakerText ? (
                <span className={"WRSpeaker"}>{activeSpeakerText}</span>
              ) : (
                <span></span>
              )}
              {!isHR ? (
                <StopWatch duration={totalSeconds < 0 ? 0 : totalSeconds} />
              ) : null}
            </div>
          </div>
          <div className={"WRRight box-layer1"}>
            <TabLayout
              tabs={tabData}
              onSelected={(index) => this.toggleChat(index === 1)}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
